import React, { useState, useEffect } from "react";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { MoreHorizontal, Share2, Trash2 } from "lucide-react";
import "./anokye-grid.css";
import { useChatContext } from "@/services/chat-provider";

export default function AnokyeGrid({ projects, onDeleteProject, onShareProject }) {
  const { useActiveProjectId } = useChatContext()

  const [_, setActiveProjectId] = useActiveProjectId()
  const history = useHistory();
  const [openMenuId, setOpenMenuId] = useState(null);
  dayjs.extend(relativeTime);

  function handleSelectProject(project) {
    setActiveProjectId(project?._id);
    history.replace("/");
  }

  function handleDeleteProject(e, id) {
    e.stopPropagation();
    if (onDeleteProject) onDeleteProject(id);
    setOpenMenuId(null);
  }

  function handleShareProject(e, project) {
    e.stopPropagation();
    if (onShareProject) onShareProject(project);
    setOpenMenuId(null);
  }

  function toggleMenu(e, id) {
    e.stopPropagation();
    setOpenMenuId(openMenuId === id ? null : id);
  }

  // Close menu on click outside
  useEffect(() => {
    const handleClickOutside = () => setOpenMenuId(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="anokye__grid-container">
      {projects.map((project) => (
        <div
          className="anokye__grid-item"
          key={project?._id}
          onClick={() => handleSelectProject(project)}
        >
          <div className="anokye__grid-item-header">
            <h3 className="anokye__grid-item-title">
              {project?.title}
            </h3>
            <div className="anokye__grid-item-menu-container">
              <button
                className="anokye__grid-item-menu-btn"
                onClick={(e) => toggleMenu(e, project?._id)}
              >
                <MoreHorizontal size={20} />
              </button>

              {openMenuId === project?._id && (
                <div className="anokye__grid-item-dropdown">
                  <button
                    className="anokye__project-dropdown-item"
                    onClick={(e) => handleShareProject(e, project)}
                  >
                    <Share2 size={16} />
                    <span>Share</span>
                  </button>
                  {/* <button
                    className="anokye__project-dropdown-item danger divider-top"
                    onClick={(e) => handleDeleteProject(e, project?._id)}
                  >
                    <Trash2 size={16} />
                    <span>Delete</span>
                  </button> */}
                </div>
              )}
            </div>
          </div>


          <div className="anokye__grid-item-footer">
            <time dateTime={project?.updatedAt} className="anokye__grid-item-status-text">
              Updated {dayjs().to(dayjs(project?.updatedAt))}
            </time>
          </div>
        </div>
      ))}
    </div>
  );
}
